import { ComponentType } from 'react';

type ToggleProps = {
    label?: string;
    Icon: ComponentType<{
        checked?: boolean,
        disabled?: boolean,
        size?: number | string,
        style?: React.CSSProperties,
    }>;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (value: boolean) => void;
    size?: number | string;
    iconStyle?: React.CSSProperties;
};

function Checkbox({
    label,
    Icon,
    checked = false,
    disabled = false,
    onChange = () => { },
    size = '1em',
    iconStyle = {},
}: ToggleProps) {
    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        onChange(event.target.checked);
    }

    return (
        <label
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                userSelect: 'none',
            }}
        >
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                style={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                }}
            />

            <Icon
                checked={checked}
                disabled={disabled}
                size={size}
                style={iconStyle}
            />

            {label && (
                <span>
                    {label}
                </span>
            )}
        </label>
    );
}

export default Checkbox;